exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-img[data-v-250e7d82]::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: #000;\n  opacity: 0.6;\n  pointer-events: none;\n}\n.invalid.card-img[data-v-250e7d82]::after {\n  opacity: 0.7;\n}\n", ""]);

// exports
